module.exports = __webpack_public_path__ + "static/02-fef4281b72ba6404a081a01f89f1c2bd.jpg";